import React from "react";
import { Modal, Button } from "react-bootstrap";

const CancelOrderModal = ({ show, handleClose, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Cancellation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to cancel the last order?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Yes, Cancel Order
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelOrderModal;
